import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";
import { EASE_EXPO, SPRING_TACTILE } from "@/lib/motion";

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);
  const visibleRef = useRef(false);

  useEffect(() => {
    const onScroll = () => {
      const next = window.scrollY > 600;
      if (next === visibleRef.current) return;
      visibleRef.current = next;
      setVisible(next);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        // whileTap rather than `active:scale-*`: Framer owns this element's
        // inline transform, so a class-based scale would be overwritten.
        <motion.a
          data-testid="floating-wa-cta"
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, scale: 0.85, y: 20 }}
          animate={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: SPRING_TACTILE,
          }}
          exit={{
            opacity: 0,
            scale: 0.9,
            y: 10,
            transition: { duration: 0.18, ease: EASE_EXPO },
          }}
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.93 }}
          className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-50 h-14 w-14 md:h-16 md:w-16 rounded-full bg-[#25D366] text-white shadow-[0_16px_40px_-8px_rgba(37,211,102,0.55)] flex items-center justify-center hover:bg-[#1FB455] transition-colors duration-200"
          aria-label="Order on WhatsApp"
        >
          <MessageCircle className="h-6 w-6 md:h-7 md:w-7" strokeWidth={1.7} />
          {/* Three pulses to catch the eye, then stop. A permanently pulsing
              corner button is nagware. */}
          <span
            aria-hidden
            style={{ animationIterationCount: 3 }}
            className="absolute inset-0 rounded-full border border-white/40 animate-ping"
          />
        </motion.a>
      )}
    </AnimatePresence>
  );
}
